/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IndexNowConditionsQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type IndexNowConditionsQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly indexNowIssuesRequiredToPass: ReadonlyArray<string>, readonly indexNowSegmentsBlocklistAllowedSegments: ReadonlyArray<string>, readonly indexNowSegmentsBlocklistDisallowedSegments: ReadonlyArray<string>, readonly indexNowSegmentsBlocklistMode: GraphQL.IndexNowSegmentsBlocklistMode, readonly indexNowUrlBlocklistMode: GraphQL.UrlBlocklistMode, readonly indexNowUrlBlocklistRules: ReadonlyArray<{ readonly __typename?: 'UrlBlocklistRule', readonly operator: GraphQL.UrlBlocklistRuleOperator, readonly value: string }> } | null };


export const IndexNowConditionsDocument = gql`
    query IndexNowConditions($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    indexNowIssuesRequiredToPass
    indexNowSegmentsBlocklistAllowedSegments
    indexNowSegmentsBlocklistDisallowedSegments
    indexNowSegmentsBlocklistMode
    indexNowUrlBlocklistMode
    indexNowUrlBlocklistRules {
      operator
      value
    }
  }
}
    `;

/**
 * __useIndexNowConditionsQuery__
 *
 * To run a query within a React component, call `useIndexNowConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexNowConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexNowConditionsQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useIndexNowConditionsQuery(baseOptions: Apollo.QueryHookOptions<IndexNowConditionsQuery, IndexNowConditionsQueryVariables> & ({ variables: IndexNowConditionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndexNowConditionsQuery, IndexNowConditionsQueryVariables>(IndexNowConditionsDocument, options);
      }
export function useIndexNowConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndexNowConditionsQuery, IndexNowConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndexNowConditionsQuery, IndexNowConditionsQueryVariables>(IndexNowConditionsDocument, options);
        }
export function useIndexNowConditionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndexNowConditionsQuery, IndexNowConditionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndexNowConditionsQuery, IndexNowConditionsQueryVariables>(IndexNowConditionsDocument, options);
        }
export type IndexNowConditionsQueryHookResult = ReturnType<typeof useIndexNowConditionsQuery>;
export type IndexNowConditionsLazyQueryHookResult = ReturnType<typeof useIndexNowConditionsLazyQuery>;
export type IndexNowConditionsSuspenseQueryHookResult = ReturnType<typeof useIndexNowConditionsSuspenseQuery>;
export type IndexNowConditionsQueryResult = Apollo.QueryResult<IndexNowConditionsQuery, IndexNowConditionsQueryVariables>;